import { Component } from '@angular/core';
import { Bind } from 'primeng/bind';
import { ButtonDirective } from 'primeng/button';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-notfound',
    templateUrl: './app.notfound.component.html',
    styleUrl: '../http-exception.scss',
    imports: [Bind, ButtonDirective, RouterLink]
})
export class AppNotfoundComponent {}
